import { AuthGroupProps } from 'interfaces/AuthProps';

export const IdentifyProfileType = (input: AuthGroupProps[]) => {
  const profileType: string[] = [];
  for (const user of input) {
    if (user.displayName.includes('app.')) {
      const prefix = user.displayName.split('.');
      const profile = `${prefix[2]}.${prefix[3]}`;
      profileType.push(profile);
    }
  }

  const filteredProfileType = profileType.filter(
    (profile, index) => profileType.indexOf(profile) === index
  );

  return filteredProfileType;
};
